export default class MapModalOpen {
  constructor() {
    this.setup();
  }
  setup() {
    $('.btn-mapmodalgps').on('click', function() {
      var src = $(this).attr('data-src');
      var iframe = $('#dealerMapGPS iframe');
      if (src !== '') {
        iframe.attr({src: src});
        $(this).attr({'data-src': ''});
      }
    });

    $('.btn-mapmodal').on('click', function() {
      var src = $(this).attr('data-src');
      var iframe = $('#dealerMapZoom iframe');
      if (src !== '') {
        iframe.attr({src: src});
        $(this).attr({'data-src': ''});
      }
    });
  }
}
